import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import FontAwesome from 'react-fontawesome';
import { selectCenter, selectConsultationDate, startIndividualConsultationEnrolment } from '../../dashboard/booking/actions';

class ClassDetails extends Component {

	componentDidMount() {
		if (!this.props.authInitializing) {
			this.initBookingOptions();
		}
	}

	componentWillReceiveProps(nextProps) {
		// wait for token refresh to complete, as booking options are reset on logout if refresh token fails
		if (this.props.authInitializing && !nextProps.authInitializing) {
			this.initBookingOptions();
		}
	}

	initBookingOptions() {
		const { centerId, date } = this.props;

		this.props.selectConsultationDate(date);
		this.props.selectCenter(centerId);
	}

	render() {
		const { selectedCenter, franchisor } = this.props;
		if (!selectedCenter) {
			return <div style={{ textAlign: 'center', fontSize: '16px', color: '#0071ac' }}>
				<FontAwesome name='spinner' spin size='3x' />
			</div>;
		}

		// start enrolment process once all required data is loaded
		this.props.startIndividualConsultationEnrolment({
			center: selectedCenter,
			consultationType: 'Assessment',
			currency: franchisor.currency,
			total: selectedCenter.individualConsultationFirstPrice
		});
		return <Redirect to={{
			pathname: '/register',
			state: { from: '/individual-consultation/booking/child' }
		}} />;
	}
}

const mapStateToProps = (state, ownProps) => {
	const centerId = Number(ownProps.match.params.centerId);
	const date = ownProps.match.params.date;

	const {
		configuration: { franchisor },
		auth,
		entities: { centers }
	} = state;

	return {
		authInitializing: auth.initializing,
		centerId,
		date,
		franchisor,
		selectedCenter: centers[centerId]
	};
};

export default connect(mapStateToProps, {
	selectCenter,
	selectConsultationDate,
	startIndividualConsultationEnrolment
})(withTranslation()(ClassDetails));